$(document).ready(function() {
  $.validate({
    lang: "de",
    modules: "html5,security",
    reCaptchaSiteKey: "6LfShZUUAAAAAOi15Q05dTYLLYZ8JVtP8CrWl0ke",
    reCaptchaTheme: "light"
  });
});  


// WEBPACK FOOTER //
// ./source/assets/js/modules/form-validation.js